<app-top-menu></app-top-menu>
<app-side-menu>
    <app-brand-logo></app-brand-logo>
    <ng-container *ngFor="let menu of navigation; let i = index">
      <app-side-nav-dropdown (openChange)="toggleAll($event, menu)" [itens]="menu.itens" [open]="menu.open" [label]="menu.label" [icon]="menu.icon">
      </app-side-nav-dropdown>
    </ng-container>
    <app-side-nav-item [label]="'Sair'" [icon]="'mdi-exit-to-app text-danger'" [route]="'logout'" bottom></app-side-nav-item>
</app-side-menu>
